

const util = require('util');

const { document } = require('window');

const _ = require('lodash');
const $ = require('jquery');


function MessageDecorator (options) {
	options = $.extend({
		// optional
		messageElement: 'label',
		messageClass: 'validation-error',
		iconElement: 'i',
		iconClass: 'validation-error-mark',
		iconFaName: null,
		textElement: 'span',
		textClass: 'validation-error-text validation-error-multiline-text',
	}, options);

	this._options = options;
}

function create (el) {
	return $('<' + el + '>');
}

MessageDecorator.prototype = {
	createElementWithMessage: function (opts) {
		opts = $.extend({
			// mandatory
			message: null, // string that should be displayed
		}, this._options, opts);

		opts.message = (String(opts.message)).replace(/[a-zа-яё]/i, function (letter) {
			return letter.toUpperCase();
		});

		const msg = create(opts.messageElement)
			.addClass(opts.messageClass);

		const icon = create(opts.iconElement)
			.addClass(opts.iconClass)
			.addClass(opts.iconFaName && 'fa fa-' + opts.iconFaName)
			.html('&nbsp;'); // space between icon and text

		const text = create(opts.textElement)
			.addClass(opts.textClass)
			.text(opts.message);

		return msg.append(icon, text);
	},

	selectMessageThatFitsContainer: function (opts) {
		opts = $.extend({
			// mandatory
			messages: null, // array of strings to select from
			container: null, // container we are trying to fit a message in
		}, opts);

		const that = this;

		opts.container = $(opts.container);

		const closestVisible = opts.container.closest(':visible');

		const dummyContainer = $('<div>'); // for width estimation
		dummyContainer[0].style.position = 'absolute';
		closestVisible.append(dummyContainer);

		const containerWidth = opts.container.width();

		const items = $.map(opts.messages, function (msg) {
			const elem = that.createElementWithMessage({ message: msg });
			dummyContainer.append(elem);
			const width = elem.width();
			elem.remove();
			return {
				msg: msg,
				width: width,
			};
		});

		dummyContainer.remove();

		items.sort(function (a, b) {
			return a.width < b.width ? -1 : (a.width > b.width ? 1 : 0);
		});

		let best = items[0].msg;
		$.each(items, function (i, item) {
			if (item.width > containerWidth) {
				return false;
			}
			best = items[i].msg;
		});

		return best;
	},
};

function FormFooterMessageDecorator () {
	MessageDecorator.apply(this, arguments);
}

util.inherits(FormFooterMessageDecorator, MessageDecorator);

function MessageAnimator (options) {
	options = $.extend(true, {
		containerHasErrorClass: 'validation-group-has-error',
		errorWrapClass: 'validation-group-error-wrap',

		animations: {
			errorFadeDuration: 500,
			labelSlideDuration: 500,
		},
	}, options);

	this._options = options;
}
MessageAnimator.prototype = {
	insertError: function (opts) {
		opts = $.extend({
			// mandatory
			error: null,
			container: null,

			// optional
			label: null,
			insertBefore: null,
		}, this._options, opts);

		opts.error = $(opts.error);
		opts.container = $(opts.container);
		opts.label = $(opts.label);
		opts.insertBefore = $(
			opts.insertBefore
				|| opts.label.next()[0]
				|| opts.container.children().first()
		);

		const insertError = function () {
			opts.container.addClass(opts.containerHasErrorClass);

			const errorWrap = $('<div>').addClass(opts.errorWrapClass);
			errorWrap.append(opts.error);

			if (opts.insertBefore[0]) {
				errorWrap.insertBefore(opts.insertBefore);
			} else { // empty container?
				errorWrap.appendTo(opts.container);
			}

			errorWrap.css('position', 'relative');
			opts.error.css({ position: 'absolute', bottom: 0, left: 0, opacity: 0 });
			opts.label.css({ position: 'relative' });
			errorWrap.add(opts.error).css('width', '100%'); // Let it text-align

			return $.when();
		};

		const fadeErrorIn = function () {
			return opts.error
				.animate({ opacity: 1 }, opts.animations.errorFadeDuration)
				.promise();
		};

		const slideLabelUp = () => {
			const errorHeight = (() => {
				if ($.contains(document, opts.error[0])) {
					// Can't just use $.outerHeight because this has to work for hidden elements too
					const h = _.sum(_.map([
						'fontSize',
						'marginTop',
						'marginBottom',
						'paddingTop',
						'paddingBottom',
					], (prop) => (parseFloat(opts.error.css(prop).replace(/px$/, '')) || 0)));
					this._lastErrorHeightEstimate = this._lastErrorHeightEstimate || h;
					return h;
				}
					// NOTE: when the error is detached from the DOM, we use previously saved height,
					// since CSS is not applied
				return this._lastErrorHeightEstimate;
				
			})();

			return opts.label
				.animate({ bottom: errorHeight }, opts.animations.labelSlideDuration)
				.promise();
		};

		return insertError().then(slideLabelUp).then(fadeErrorIn);
	},

	removeError: function (opts) {
		opts = $.extend({
			// mandatory
			container: null,

			// optional
			error: null,
			label: null,
		}, this._options, opts);

		opts.container = $(opts.container);
		// default error selector is a compatibility HACK
		opts.error = $(
			opts.error
			|| opts.container.find('.' + opts.errorWrapClass + ' > *')
		);
		opts.label = $(opts.label);

		const slideLabelDown = function () {
			return opts.label
				.animate({ bottom: 0 }, opts.animations.labelSlideDuration)
				.promise();
		};

		const fadeErrorOut = function () {
			return opts.error
				.fadeOut(opts.animations.errorFadeDuration)
				.promise();
		};

		const removeError = function () {
			const errorWrap = opts.error.closest('.' + opts.errorWrapClass);
			errorWrap.remove();

			opts.container.removeClass(opts.containerHasErrorClass);

			return $.when();
		};

		return fadeErrorOut().then(slideLabelDown).then(removeError);
	},

	replaceError: function (opts) {
		opts = $.extend({
			// mandatory
			currentError: null,
			newError: null,
		}, this._options, opts);

		opts.currentError = $(opts.currentError);
		opts.newError = $(opts.newError);

		const insertNewError = function () {
			const errorWrap = opts.currentError.closest('.' + opts.errorWrapClass);
			errorWrap.append(opts.newError);

			opts.newError.css({
				position: 'absolute',
				bottom: 0, left: 0,
				opacity: 0,
				width: '100%',
			});

			return $.when();
		};

		const fadeCurrentErrorOut = function () {
			return opts.currentError
				.animate({ opacity: 0 }, opts.animations.errorFadeDuration)
				.promise();
		};

		const fadeNewErrorIn = function () {
			return opts.newError
				.animate({ opacity: 1 }, opts.animations.errorFadeDuration)
				.promise();
		};

		const removeCurrentError = function () {
			opts.currentError.remove();
			return $.when();
		};

		return insertNewError()
			.then(function () {
				return $.when(fadeCurrentErrorOut(), fadeNewErrorIn());
			})
			.then(removeCurrentError);
	},
};

function ControlHighlighter (options) {
	options = $.extend({
		// optional
		controlHighlightedClass: 'validation-control-has-error',
		controlHighlightedSuccessClass: 'validation-control-has-success',
	}, options);

	this._options = options;
}
ControlHighlighter.prototype = {
	highlight: function (opts) {
		opts = $.extend({
			// mandatory
			control: null,
		}, this._options, opts);

		$(opts.control).removeClass(opts.controlHighlightedSuccessClass);
		$(opts.control).addClass(opts.controlHighlightedClass);

		return $.when();
	},
	highlightSuccess: function (opts) {
		opts = $.extend({
			// mandatory
			control: null,
		}, this._options, opts);

		$(opts.control).removeClass(opts.controlHighlightedClass);
		$(opts.control).addClass(opts.controlHighlightedSuccessClass);

		return $.when();
	},
	unhighlight: function (opts) {
		opts = $.extend({
			// mandatory
			control: null,
		}, this._options, opts);

		$(opts.control).removeClass(opts.controlHighlightedClass);
		$(opts.control).removeClass(opts.controlHighlightedSuccessClass);

		return $.when();
	},
};

module.exports = {
	MessageDecorator: MessageDecorator,
	FormFooterMessageDecorator: FormFooterMessageDecorator,
	MessageAnimator: MessageAnimator,
	ControlHighlighter: ControlHighlighter,
};

